import './App.css';
import Layout from './components/Layout';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LocaleProvider } from './context/LocaleContext';
import { RedirectionProvider } from './context/RedirectionContext';
import HomePage from './pages/HomePage';
import TransactionsPage from './pages/TransactionsPage';
import InventoryPage from './pages/InventoryPage';
import BarcodePage from './pages/BarcodePage';
import ReportPage from './pages/ReportPage';
import ForecastPage from './pages/ForecastPage';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './data/theme';
import UnderConstruction from './components/UnderConstruction';

function App() {
	return (
		<LocaleProvider>
			<BrowserRouter>
				<ThemeProvider theme={theme}>
					<RedirectionProvider>
						<CssBaseline />
						<Layout>
							<Routes>
								<Route path='/dashboard' element={<HomePage />} />
								<Route path='/transactions' element={<TransactionsPage />} />
								<Route path='/inventory' element={<InventoryPage />} />
								<Route path='/barcode' element={<BarcodePage />} />
								<Route path='/report' element={<ReportPage />} />
								<Route path='/forecast' element={<ForecastPage />} />
								<Route path='/profile' element={<UnderConstruction />} />
								<Route path='/logout' element={<UnderConstruction />} />
							</Routes>
						</Layout>
					</RedirectionProvider>
				</ThemeProvider>
			</BrowserRouter>
		</LocaleProvider>
	);
}

export default App;
